import { render, staticRenderFns } from "./MeloLive.vue?vue&type=template&id=5a731eb7"
import script from "./MeloLive.vue?vue&type=script&lang=js"
export * from "./MeloLive.vue?vue&type=script&lang=js"
import style0 from "./MeloLive.vue?vue&type=style&index=0&id=5a731eb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports